import { useCallback } from "react";
import useFeature from "hooks/useFeature";
import { getBarChartTraceOffsetGroup } from "views/components/visualizations/utils/chartLayoutGenerators";
import { UNIT_FEATURE_FLAG } from "views/components/visualizations/Constants";
import useChartDataSettingsWithCustomUnits from "views/components/visualizations/hooks/useChartDataSettingsWithCustomUnits";
const useBarChartDataSettingsWithCustomUnits = ({
  config,
  barmode
}) => {
  const unitFeatureEnabled = useFeature(UNIT_FEATURE_FLAG);
  const getChartDataSettingsWithCustomUnits = useChartDataSettingsWithCustomUnits({ config });
  return useCallback(
    ({
      values,
      idx,
      fullPath,
      name
    }) => {
      if (!unitFeatureEnabled) return {};
      const {
        y: convertedValues,
        yaxis,
        ...hoverTemplateSettings
      } = getChartDataSettingsWithCustomUnits({ name, fullPath, values });
      const offsetgroup = getBarChartTraceOffsetGroup(barmode, yaxis, idx);
      return {
        yaxis,
        y: convertedValues,
        fullPath,
        offsetgroup,
        ...hoverTemplateSettings
      };
    },
    [barmode, getChartDataSettingsWithCustomUnits, unitFeatureEnabled]
  );
};
export default useBarChartDataSettingsWithCustomUnits;
